import { useTranslation } from 'react-i18next';
import { Table } from '@scramble/ui';
import { prettyMoney } from '@scramble/utils';
import { prettyDate } from '@/helpers/utils';
import { EMPTY_DASH } from '@/helpers/constants';
import { DATE_FORMAT_DD_MM_YYYY } from '@/helpers/common';
import s from './index.module.scss';

export const TableView = props => {
  const { t } = useTranslation();
  const {
    repayment_schedule,
    total,
    total_earnings,
    total_principals,
    increased_income,
  } = props.data;

  return (
    <div className={s.wrapper}>
      <Table minWidth={688}>
        <Table.Header>
          <Table.HeaderCell> {t('investing:repayment_schedule.month')}</Table.HeaderCell>
          <Table.HeaderCell>
            {t('investing:repayment_schedule.your_earnings')}
          </Table.HeaderCell>
          <Table.HeaderCell>
            {t('investing:repayment_schedule.principal')}
          </Table.HeaderCell>
          <Table.HeaderCell>{t('investing:repayment_schedule.total')}</Table.HeaderCell>
        </Table.Header>
        <Table.Body>
          {repayment_schedule.map((loan, index) => {
            const isLastMonth = index === repayment_schedule.length - 1;
            return (
              <Table.Row key={index}>
                <Table.Cell>
                  {prettyDate(loan.date, DATE_FORMAT_DD_MM_YYYY)}
                </Table.Cell>
                <Table.Cell>
                  {loan.earnings
                    ? prettyMoney(
                        isLastMonth
                          ? loan.earnings + increased_income
                          : loan.earnings,
                        { rounding: 'halfUp' },
                      )
                    : EMPTY_DASH}
                </Table.Cell>
                <Table.Cell>
                  {loan.principal
                    ? prettyMoney(loan.principal, { rounding: 'halfUp' })
                    : EMPTY_DASH}
                </Table.Cell>
                <Table.Cell>
                  {loan.total
                    ? prettyMoney(
                        isLastMonth
                          ? loan.total + increased_income
                          : loan.total,
                        { rounding: 'halfUp' },
                      )
                    : EMPTY_DASH}
                </Table.Cell>
              </Table.Row>
            );
          })}

          <Table.Row>
            <Table.Cell>{t('investing:repayment_schedule.total')}:</Table.Cell>
            <Table.Cell>
              {total_earnings
                ? prettyMoney(total_earnings + increased_income, {
                    rounding: 'halfUp',
                  })
                : EMPTY_DASH}
            </Table.Cell>
            <Table.Cell>
              {total_principals
                ? prettyMoney(total_principals, {
                    rounding: 'halfUp',
                  })
                : EMPTY_DASH}
            </Table.Cell>
            <Table.Cell>
              {total
                ? prettyMoney(total + increased_income, {
                    rounding: 'halfUp',
                  })
                : EMPTY_DASH}
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    </div>
  );
};
